import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/features';
import { ResortErrorType } from 'src/features/resort';
import { RequestState } from 'src/features/utils/RequestState';
import { UserResortProfile } from 'src/models/resort/UserResortProfile';

interface ResortPromotionInfo {
  profile: UserResortProfile;
  isFollowing: boolean;
}

export const resortInfoSelector = createSelector(
  [
    (state: RootState) => state.resort.displayedUserProfile,
    (state: RootState) => state.resort.followList
  ],
  (userProfile, followList): RequestState<ResortPromotionInfo, ResortErrorType> | undefined => {
    if (userProfile?.state === 'error') {
      return { state: 'error', error: userProfile.error };
    }
    if (followList?.state === 'error') {
      return { state: 'error', error: followList.error };
    }
    if (userProfile?.state === 'pending' || followList?.state === 'pending') {
      return { state: 'pending' };
    }
    if (userProfile?.state === 'ok' && followList?.state === 'ok') {
      const isFollowing =
        followList.result.find(
          user => user.resortPlannerId === userProfile.result.resortPlannerId
        ) !== undefined;
      return {
        state: 'ok',
        result: {
          profile: userProfile.result,
          isFollowing
        }
      };
    }
    return undefined;
  }
);
